import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getInvoiceItems(invoiceId, params) {
        return Axios.get(
            `${baseURL}billing/invoice/invoice_items/${invoiceId}`,
            {
                params: params
            }
        ).then(res => {
            if (
                res &&
                res.data &&
                res.data.response &&
                res.data.response.resources
            ) {
                return res.data.response.resources;
            }
            return [];
        });
    },
    getInvoiceItem(invoiceItemId) {
        return Axios.get(
            `${baseURL}billing/invoice-item/${invoiceItemId}`
        ).then(res => {
            if (
                res &&
                res.data &&
                res.data.response &&
                res.data.response.resources
            ) {
                return res.data.response.resources;
            }
            return null;
        });
    },
    updateInvoiceItemOrder(params) {
        return Axios.post(
            `${baseURL}billing/invoice-item/reorder`,
            params
        ).then(res => {
            if (res.data) {
                return res.data.response;
            }
            return [];
        });
    },
    declineItem(params) {
        return Axios.post(
            `${baseURL}billing/invoice-item/declineInvoiceItem`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    deleteItem(invoiceId, params) {
        return Axios.delete(`${baseURL}billing/invoice-item/${invoiceId}`, {
            params
        }).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    bulkDelete(params) {
        return Axios.post(
            `${baseURL}billing/delete-multiple-invoice-items`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    addBundle(params) {
        return Axios.post(`${baseURL}billing/invoice/add-bundle`, params).then(
            res => {
                if (res && res.data) {
                    return res.data.response;
                }
                return null;
            }
        );
    },
    getPlanByPatient(params) {
        return Axios.post(
            `${baseURL}billing/invoice-item/get-plan-by-patient`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response.resource;
            }
            return null;
        });
    },
    getTaxFeeByItem(itemId, params) {
        return Axios.post(
            `${baseURL}inventory/${itemId}/tax-fee-by-item`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response.resources;
            }
            return null;
        });
    },
    calculateDiscount(params) {
        return Axios.post(
            `${baseURL}billing/invoice-item/calculate-discount`,
            params
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response.resource;
            }
            return null;
        });
    },
    calculateNegativeInvoiceTotal(params) {
        return Axios.post(
            `${baseURL}billing/invoice-item/check-negative-invoice-total`,
            params
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response.resource;
            }
            return null;
        });
    },
    postSave(params) {
        return Axios.post(`${baseURL}billing/invoice-item`, params).then(
            res => {
                if (res.data) {
                    return res.data.response;
                }
                return [];
            }
        );
    },
    postEdit(params) {
        return Axios.post(
            `${baseURL}billing/invoice-item/update-invoice-item`,
            params
        ).then(res => {
            if (res.data) {
                return res.data.response;
            }
            return [];
        });
    },
    precalculateItem(params) {
        return Axios.post(
            `${baseURL}billing/invoice-item/precalculate-item`,
            params
        ).then(res => {
            if (res.data) {
                return res.data.response;
            }
            return [];
        });
    },
    calculatePriceTier(params) {
        return Axios.post(
            `${baseURL}billing/invoice-item/calculate-price-tier`,
            params
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response.resource;
            }
            return null;
        });
    },
    getFeePrices(params) {
        return Axios.post(
            `${baseURL}billing/invoice-item/get-fees`,
            params
        ).then(res => {
            if (res && res.data) {
                return res.data.response;
            }
            return null;
        });
    }
};
